import {createStore} from '../utilities/storeUtils';
import {isPresent, isGtZero} from '../utilities/general';
import  _ from 'underscore';
import {normalize} from 'normalizr';
import {asnDetailsKeyToArrayOfAsnDetails} from './relationships';
window._underscore = _;

let asnDetails = {};
const defaults = {
  sku: "",
  unitsPerCase: 1,
  numberOfCases: 1,
  numberOfPallets: 1,
  caseLineNumber: 1,
  palletLineNumber: 1
  // skuLineNumber: 1
};

const AsnDetailStore = createStore({
  storeEventBaseKey: "asn_details",
  normalizrKey: "asnDetails",
  normalizr: asnDetailsKeyToArrayOfAsnDetails,
  getData(){
    return asnDetails;
  },
  getDefaults(){
    return defaults;
  },
  calcTotalQuantityForDetails(details){
    let total = 0;
    _(details).map((detail)=>{
      total += this.calcTotalQuantityFor(detail);
    });
    return total;
  },
  calcTotalQuantityFor(detail){
    const {unitsPerCase, numberOfCases, numberOfPallets} = detail;
    return defaultToOne(unitsPerCase) * defaultToOne(numberOfCases) * defaultToOne(numberOfPallets);
  },
  setNumberOfCasesForIds: setAttrForIdsFunc("numberOfCases"),
  setNumberOfPalletsForIds:setAttrForIdsFunc("numberOfPallets"),
  setLengthForIds: setAttrForIdsFunc("asd_package_length"),
  setWidthForIds: setAttrForIdsFunc("asd_package_width"),
  setHeightForIds: setAttrForIdsFunc("asd_package_height"),
  setWeightForIds: setAttrForIdsFunc("asd_package_weight"),
  setAttrsForIds: setAttrsForIds,
  isSingularInPallet(detail){
    return !_(asnDetails).find((curDetail, k)=>{
      return detail.id !== curDetail.id && detail.palletLineNumber === curDetail.palletLineNumber;
    });
  },
  copyDimensionsToAllCasesForSameAsn(asnDetailId){
    const asnDetail = this.getAsnDetail(asnDetailId);
    const {asd_package_length, asd_package_width, asd_package_height, asd_package_weight, stackablePallet} = asnDetail;
    let similarAsnDetails = _(asnDetails).pick(({asnId})=>{
      return asnDetail.asnId === asnId;
    })
    similarAsnDetails = _(similarAsnDetails).mapObject((curAsnDetail)=>{
      return _.assign(curAsnDetail, {asd_package_length, asd_package_width, asd_package_height, asd_package_weight, stackablePallet})
    });
    this.updateObjectsAndEmit(similarAsnDetails);
  },
  copyObjectToAllCasesViaAsnId(asnId,newData){
    let similarAsnDetails = _(asnDetails).pick((asnDetail)=>{
      return asnDetail.asnId === asnId;
    })

    similarAsnDetails = _(similarAsnDetails).mapObject((curAsnDetail)=>{
      return _.assign(curAsnDetail, newData)
    });
    this.updateObjectsAndEmit(similarAsnDetails);
  },
  createNewPalletIncrementedAsnDetail(data){
    const getNextFunc = getNextIntegerFor.bind(this);
    const palletLineNumber = getNextFunc("palletLineNumber");
    return this.createNewAsnDetail({...data, caseLineNumber: 1, palletLineNumber});
  },

  removeAsnDetailsByIds(caseIds=[]){
    this.removeObjectsByIdsAndEmit(asnDetails, caseIds);
  },
  createNewCaseIncrementedAsnDetail(data){
    const getNextFunc = getNextIntegerFor.bind(this);
    const caseLineNumber = getNextFunc("caseLineNumber");
    return this.createNewAsnDetail({...data, caseLineNumber});
  },
  maxBy(key){
    //based on shippingMethod
    const details = AsnStore.getAsnDetails(getAsnByKey(key));
    return _(details).max((obj)=>{
      return parseInt(obj[key]);
    });
  },
  update(id, newData){
		const detail = asnDetails[id];
    asnDetails[id] = {...detail, ...newData};
    // emit a global/generic change that we can listen to
    this.emitEvent("change", detail);
    return this.emitObjectChange(asnDetails[id]);
  },
  createNewCaseSkeletonIncrementedAsnDetail(data){
    const getNextFunc = getNextIntegerFor.bind(this);
    const caseLineNumber = getNextFunc("caseLineNumber");
    return this.createSkeletonAsnDetail({...data, caseLineNumber});
  },
  getNextCaseNumber(){
    const getNextFunc = getNextIntegerFor.bind(this);
    return getNextFunc("caseLineNumber");
  },
  getNextPalletNumber(){
    const getNextFunc = getNextIntegerFor.bind(this);
    return getNextFunc("palletLineNumber");
  },
  createNewPalletSkeletonIncrementedAsnDetail(data){
    const getNextFunc = getNextIntegerFor.bind(this);
    const palletLineNumber = getNextFunc("palletLineNumber");
    return this.createSkeletonAsnDetail({...data, caseLineNumber: 1, palletLineNumber});
  },
  createSkeletonAsnDetail(data){
    return _.extend({id: _.uuid()}, defaults, data);
  },
  createNewAsnDetail(data){
    data = _.extend({id: _.uuid()}, defaults, data);
    return this.addAsnDetail(data);
  },
  addAsnDetail(data){
    return this.addObjectsAndEmit(asnDetails, data);
  },
  getAllAsnDetails(){
    return asnDetails;
  },
  getAsnDetail(id){
    return asnDetails[id];
  },
  getAsnDetails(ids){
    return _.chain(asnDetails).pick(...ids).values().value();
  },
  asnDetailsAsArray(){
    return _(asnDetails).values();
  },
  haveDimensionsAndWeight(details){
    return _(details).all(this.hasDimensionsAndWeight, this);
  },
  hasDimensionsAndWeight(detail){
    return (
      isGtZero(detail.asd_package_length) &&
      isGtZero(detail.asd_package_width) &&
      isGtZero(detail.asd_package_height) &&
      isGtZero(detail.asd_package_weight)
    );
  },
  organizeIntoPalletsAndCases(details){
    return _.chain(this.organizeIntoPallets(details)).map((palletData)=>{
      return this.organizeIntoCases(palletData);
    }).value();
  },
  organizeIntoPallets: organizeIntoFunc("palletLineNumber"),
  organizeIntoCases: organizeIntoFunc("caseLineNumber"),

  hasAnyMixedSkuCasesInAnyPallets(details){
    return _(this.organizeIntoPalletsAndCases(details)).any((palletData)=>{
      return arrayIsGreaterThanOne(palletData) || _(palletData).any(arrayIsGreaterThanOne);
    });
  },
  hasAnyMixedSkuCases(details){
    return _(this.organizeIntoCases(details)).any(arrayIsGreaterThanOne);
  },
  groupBySku(details=[]){
    return _(details).groupBy((detail)=>{
      return detail.sku;
    });
  },
  where(attrs){
    return _(this.asnDetailsAsArray()).where(attrs);
  },
  whereAsObject(attrs){
    return _(asnDetails).pick((detail, id)=>{
      return !!_([detail]).where(attrs).length;
    });
  },
  storeFromUploadJson(newArray) {
    const asn = AsnStore.getAsnWithShippingMethod();
    const curNormalizr = this.normalizr;
    const newData = normalize({asnDetails: newArray}, curNormalizr).entities.asnDetails;
    var dvlForAllResult=false;

    _(newData).map((item)=>{
      if(item.dvlForAll!='undefined'){
          dvlForAllResult=item.dvlForAll;
      }
    });
    //alert(dvlForAllResult);
    //AsnStore.updateObjectAndEmit(asn.id, {[key]: val});
    AsnStore.updateObjectAndEmit(asn.id, {"applyDvl": dvlForAllResult});
    //AsnStore.emitEvent("dvl-inside-case");
    asnDetails = _(asnDetails).omit((asnDetail)=>{
      return asnDetail.asnId === asn.id;
    })

    asnDetails = {...asnDetails, ...newData};

    //this.emitEvent('add', newData);
  }
})

function getAsnByShippingMethod(shippingMethod){
  return AsnStore.getOrCreateAsnWithShippingMethod(shippingMethod);
}

function getAsnByKey(key){
  if(key == 'palletLineNumber')
    return getAsnByShippingMethod("pallet");
  else
    return getAsnByShippingMethod("parcel");
}

function defaultToOne(numb){
  return (numb || 1);
}

function setAttrForIdsFunc(groupKey){
  return function(ids, val){
    const out = _.chain(asnDetails).pick(...ids).mapObject((detail, k)=>{
      detail[groupKey] = val;
      return detail;
    }).mapObject((detail, k)=>{
      this.emitObjectChange(detail);
    }).value();
    // emit a global change as well
    this.emitEvent('change', out);
    this.emitEvent(`changes:${groupKey}`, out);

    return out;
  }
}

function setAttrsForIds(ids, attrs={}){
  _(attrs).mapObject((v, k)=>{
    const func = setAttrForIdsFunc(k).bind(this);
    func(ids, v);
  });
}


function getNextIntegerFor(key){
  let numb = this.maxBy(key)[key];
  if(_.isNull(numb) || _.isUndefined(numb) || numb === ""){
    numb = 0;
    // console.log('null or undefined for max key');
  }
  numb = parseInt(numb, 10);
  return numb + 1;
}

function arrayIsGreaterThanOne(arr){
  return arr.length > 1;
}

function organizeIntoFunc(key){
  return (data)=>{
    return _.chain(data).values().groupBy((asnDetail)=>{
      return asnDetail[key];
    }).values().value();
  }
}
window.AsnDetailStore = AsnDetailStore;
export default AsnDetailStore



// WEBPACK FOOTER //
// ./src/stores/AsnDetailStore.js